function convertEntities(text) {
  if (typeof text !== 'string' || typeof document === 'undefined') return text;

  const decoder = document.createElement('textarea');
  let decoded = text;

  for (let attempt = 0; attempt < 5; attempt += 1) {
    decoder.innerHTML = decoded;
    const next = decoder.value;
    if (next === decoded) break;
    decoded = next;
  }

  return decoded;
}

export function convertEntitiesDeep(value) {
  if (typeof value === 'string') return convertEntities(value);
  if (Array.isArray(value)) return value.map(convertEntitiesDeep);
  if (
    value &&
    typeof value === 'object' &&
    (Object.getPrototypeOf(value) === Object.prototype ||
      Object.getPrototypeOf(value) === null)
  ) {
    return Object.keys(value).reduce((decoded, key) => {
      decoded[key] = convertEntitiesDeep(value[key]);
      return decoded;
    }, {});
  }

  return value;
}

export default convertEntities;
